import { textReducer } from './textReducer';
import * as selectors from './textSelectors';
import * as actions from './textActions';

export { textReducer, selectors, actions };
